package com.trevorwiebe.timesheet.more.presentation

import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.core.domain.model.Rate

data class MoreState(
    val currentUser: DatabaseUserModel? = null,
    val userLoading: Boolean = true,
    val userLoadFailed: Boolean = false,
    val confirmSignOutSheet: Boolean = false,
    val signOutLoading: Boolean = false,
    val totalHoursWorkedThisYear: String = "0",
    val rates: List<Rate> = emptyList(),
    val hoursWorked: List<Pair<String, Double>> = emptyList()
)